import React, { Component, useEffect, useState } from "react";
import { HeadingTextWrapper } from '../../common/Headings';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Tabs from './casino-tab';
import { useMutation } from "@apollo/client";
import { ONE_CLICK_RECYCLE } from "src/graphql/system";
import PlayDemoGames from "./bingo-slotGames";
import styled, { createGlobalStyle, withTheme } from 'styled-components';
import { withAppContext } from 'src/store/initAppContext';
import { motion } from 'framer-motion'
import config from "src/config/config";
import Intl from '../../common/Intl';
import { SEOFooterCommon, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { slotsGamesSEOData } from "src/config/seo_api";
import { getGamesJsonData } from "src/util/gameDataLoader";
import Spinner from "src/components/common/Spinner";
import { addressablePxlPageView } from "src/util/addressablePxl";


function SlotGames(props: any) {
    const { app: { brandId }, theme: { config } } = props;
    const { showAPISEOData } = config;

    const { id: gameName, provider: providerName } = useParams();
    const location = useLocation();
    const [triggerOneClickRecycle, { recycleLoading, recycleError, recycleData }]: any = useMutation(ONE_CLICK_RECYCLE);

    const [gameData, setGameData] = useState({});
    const [slotGame, setSlotGame] = useState([]);
    const [filteredData, setfilteredData] = useState([]);
    const [providerList, setProviderList] = useState([]);
    const [providerTab, setProviderTab] = useState([]);
    const [providerIcons, setProviderIcons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [seoObjects, setseoObjects] = useState({});

    //Next Change : unique URL for each game.
    const navigate = useNavigate()
    const state:any = location.state || {};
    const action = state.play;
    //END : unique URL for each game.

    const getLastqueryString = location.pathname.split("/").pop();

    useEffect(() => {
        window.scrollTo(0, 0);
        //need to remove play state on refresh
        if(action){
           navigate(location.pathname) 
        }
    }, [])

    useEffect(() => {
        const loadGames = async () => {
            try {
                const data = await getGamesJsonData("slotgames", brandId);
                setGameData(data);

                const { providers = [], gameData: games = [] } = data;

                // Set providerList
                const providerCategoryList = providers.map((ele: any) => ele.category);
                setProviderList(providerCategoryList);

                // Set provider Icons tab buttons
                const iconList = providers.map((ele: any) => ({
                    id: ele.id,
                    name: <Intl langKey={ele.displayKey} />,
                    icon: ele.icon,
                }));
                setProviderIcons(iconList);

                // Set tab names
                const tabNames = iconList.map((ele: any) => ele.name);
                setProviderTab(tabNames);

                // Set games
                setSlotGame(games);
                setfilteredData(games);
            } catch (err) {
                console.error("Failed to load game data:", err);
            } finally {
                setLoading(false);
            }
        };

        loadGames();
        //addressablePxl
        addressablePxlPageView(brandId);
        window.scrollTo(0, 0);
    }, [brandId])

    let history: any = useNavigate();

    const backButton = () => {

        window.location.reload();
        triggerOneClickRecycle()
            .then((response) => {
                if (response) {
                    return;
                }
            })
            .catch((error) => {
                console.log("Error in one click recycle");
            });
    }

    // const searchData = (val) => {
    //     setSearch(val)
    //     if (val !== "") {
    //         const filteredItems = slotGame.filter((item) => {
    //             //MS - Modifying Search feature for better result
    //             let type = item.type.toLowerCase() && item.type.toLowerCase().replace(/[\_\-\'\s]/gi, '');
    //             let _val = val && val.replace(/[\_\-\'\s]/gi, '');
    //             let slug = item.slug ? item.slug.replace(/[\_\-\'\s]/gi, '') : '';
                
    //          // Check if either type or slug matches the search value
    //          if (type.toLowerCase().includes(_val.toLowerCase()) || slug.toLowerCase().includes(_val.toLowerCase())) {
    //             return item;
    //         } else {
    //             const { imgsrc, ...rest } = item;
    //             // Fallback: Search through all other fields in the object
    //             return Object.values(rest).join('').toLowerCase().includes(val.toLowerCase());
    //         }
                
    //         })
    //         setfilteredData(filteredItems)
    //     }
    //     else {
    //         setfilteredData(slotGame)
    //     }
    // }

    const searchData = (val: any) => {
        //Next Change : unique URL for each game.
         if(action) return ;
        //END : unique URL for each game.

        setSearch(val);

        if (val !== "") {
            let _val = val && val.replace(/[\_\-\.\'\s]/gi, '').toLowerCase();

            const filteredItems = slotGame.filter((item) => {
                const { game = '', catagoryName = '', type = '', slug = '' } = item;

                const normalizedGame = game.replace(/[\_\-\.\'\s]/gi, '').toLowerCase();
                const normalizedCategoryName = catagoryName.replace(/[\_\-\'\s]/gi, '').toLowerCase();
                const normalizedType = type.replace(/[\_\-\'\s]/gi, '').toLowerCase();

                // Additional condition added for Handle slug as either string or array
                const slugList = Array.isArray(slug) ? slug : [slug];
                const normalizedSlugs = slugList.map(s =>
                    s.replace(/[\_\-\'\s]/gi, '').toLowerCase()
                );

                // if (Array.isArray(slug) && slug.some((item: string) => item.replace(/[\_\-\'\s]/gi, '').toLowerCase().startsWith(_val))) {
                // //searchOn = ['slug']
                // return item;
                // } else if (typeof slug === 'string' && slug.replace(/[\_\-\'\s]/gi, '').toLowerCase().startsWith(_val)) {
                // //searchOn = 'slug'
                //     return item;
                // }

                return (
                    normalizedGame.includes(_val) ||
                    normalizedCategoryName.includes(_val) ||
                    normalizedType.includes(_val) ||
                    normalizedSlugs.some(s => s.includes(_val))
                );
            });

            setfilteredData(filteredItems);
        } else {
            // Reset to original data when search input is empty
            setfilteredData(slotGame);
        }
    };

    const budgetData = () => {

    }

    //for SEO
    useEffect(() => {
    if (showAPISEOData) {
        const getSeoData = slotsGamesSEOData();
        const pathName = location.pathname;

        getSeoData.then(resp => {
        const { objects } = resp;
        const seoData = objects.find((obj: any) => {
            const { metadata = {} } = obj;
            if (metadata.pathname && metadata.pathname === pathName) {
            return obj;
            }

        }) || {};

        const { metadata = {} } = seoData;
        setseoObjects(metadata);

        }).catch(error => console.log(`[${pathName}]:Error in SEO API`))

    }
    }, [providerName]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}
            
            {/* <SlotWrapper style={{width:"100%", height:"84vh"}} theme={props.app.theme} customStyle={props.theme.image} > */}
            <SlotWrapper theme={props.app.theme} customStyle={props.theme.image} >
                <TitleHead theme={props.app.theme} customStyle={props.theme.palette}><Intl langKey="TITLE@SLOTGAME" /> & <Intl langKey="TITLE@BINGO" /></TitleHead>
                {/* <BackButton onClick={backButton}> <img src={LeftArrow}/>
                    Back
                </BackButton> */}

                {loading ? (
                    <Spinner />
                ) : (
                    <TabListSection>
                        <Tabs
                            searchText={search}
                            providerIcons={providerIcons}
                            tabs={providerTab}
                            onSearch={searchData}
                            isTabsHidden={false}
                            budgetClick={budgetData}
                            minWidthInContent={"initial"}
                            providerList={providerList}
                            render={(index: any) => {
                                const selectedProvider = providerList[index];
                                const isAllGames = !selectedProvider || selectedProvider === 'all';

                                const filteredGameData = isAllGames ? filteredData
                                    : filteredData.filter((game) => (game.type || '').toLowerCase() === selectedProvider.toLowerCase());

                                return <PlayDemoGames data={filteredGameData} key={selectedProvider}/>
                            }}
                        />
                    </TabListSection>
                )}
            </SlotWrapper>

            {/* New SEO Footer */}
            {showAPISEOData && <SEOFooterCommon footer_title={seoObjects['seo_footer_title_(h1)']} footer_content={seoObjects['seo_footer_content']} />}


            {}
        </motion.div>
    );

};

export default withTheme(withAppContext(SlotGames));


const SlotWrapper: any = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    /* margin-top: -5px; */
    // height: 87vh;
    /* background-image: url('${(props: any) => (props.theme === 'Dark' ? `${config.imageS3Host}/static/snk/${props.customStyle['new_whitelable_dark_background']}` : `${config.imageS3Host}/static/snk/${props.customStyle['new_whitelable_light_background']}`)}'); */
    background-image: url('${(props: any) => `${config.imageV3Host}/static/cashsite/${props.customStyle['homeExchangeBgImage']}`}');
    background-position: 100%;
    background-size: cover;
`;

const TabListSection = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    
`;

const TitleHead: any = styled(HeadingTextWrapper)`
    font-size: 28px;
    letter-spacing: 3px;
    text-transform: uppercase;
    white-space: nowrap;
    font-weight: bold;
    /* color: ${(props: any) => (props.theme === 'Dark' ? '#FFF' : '#F4A322')}; */
    color: ${(props:any) => (props.theme === 'Dark' ? '#FFF' : props.customStyle['casinoTitleHeadTextColor'])};
    margin-left: 1em;
    padding-top: 10px;
    
    position: relative;
    margin-bottom: 10px;
    padding-bottom: 5px;

    :after {
        content: "";
        width: 500px;
        height: 2px;
        background: ${(props:any) => (props.customStyle['casinoTitleHeadBorderBtmLineColor'])};
        position: absolute;
        bottom: 0;
        left: 0;
    }
	
	@media only screen and (max-width: 992px){
		font-size: 30px;
	}	
`;

export const Col1: any = styled.div`
    width: 100%;
    height: 275px;
    display: flex;
    background-image: url(${(props: any) => props.imageSrc});
    background-size: cover;
    background-repeat: no-repeat;
`;
